import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, first, map, Observable, of } from "rxjs";
import { AuthService } from "src/app/services/auth-service/auth.service";

export const AuthGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isAuthenticated().pipe(
    first(),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        router.navigate(["/login"]);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(["/login"]);
      return of(false);
    }),
  );
};
